import type { Stream } from '../api/client.ts';
import { t } from '../i18n/index.ts';
import { formatClock, formatBytes } from '../lib/format.ts';

interface Props {
  stream: Stream;
  timeZone: string;
  selected: boolean;
  onSelect: () => void;
}

export function StreamCard({ stream, timeZone, selected, onSelect }: Props): React.ReactElement {
  const { from, to } = stream.coverage;

  return (
    <div
      className={`stream-card ${selected ? 'selected' : ''}`}
      onClick={onSelect}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onSelect();
        }
      }}
      role="button"
      tabIndex={0}
      aria-pressed={selected}
    >
      <span className="stream-name">{stream.name}</span>

      <span className={`state-flag ${stream.is_live ? 'on' : 'off'}`}>
        {stream.is_live ? t('stream.live') : t('stream.offline')}
      </span>

      <span className="stat">
        <span className="k">{t('stream.coverage')}</span>
        {/* A span of clock time is an axis: left to right. */}
        <span className="v m" dir="ltr">
          {from && to ? `${formatClock(from, timeZone)} – ${formatClock(to, timeZone)}` : '—'}
        </span>
      </span>

      <span className="stat">
        <span className="k">{t('stream.bitrate')}</span>
        <span className="v m" dir="ltr">
          {stream.bitrate_kbps ? `${stream.bitrate_kbps} ${t('unit.kbps')}` : '—'}
        </span>
      </span>

      <span className="stat">
        <span className="k">{t('stream.archive_size')}</span>
        <span className="v m" dir="ltr">{formatBytes(stream.archive_bytes)}</span>
      </span>
    </div>
  );
}
